import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import React from 'react'
import { FeaturesType } from 'src/types'

import { SpanDataList } from './SpanDataList'

interface SpanDataIconProps {
  features: FeaturesType[]
}
export const SpanDataIcon: React.FC<SpanDataIconProps> = ({ features = [] }) => {
  return (
    <div className="flex flex-row items-center">
      <IonIcon
        name="earth-outline"
        className={cn(
          `text-[1.5rem] mr-[0.625rem] ${
            features.length > 0 && features[0].iconColor && `text-[${features[0].iconColor}]`
          }`,
        )}
      />
      <SpanDataList features={features} type="normal" />
    </div>
  )
}
